




































































































































import {
  defineComponent, reactive, ref, Ref, watch, computed, onMounted,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  createPurchaseRequest,
  getSubJobs,
  searchSubJob,
  getSuppliers,
} from '@/api/index';

import createTreatmentTableOption from '@/table/PurchaseRequest/create-treatment-request';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonCheckBoxRenderer from '@/components/CommonCheckBoxRenderer.vue';

const NOW = useFormat.date().computerShortDate();
const TOMORROW = useFormat.date(useFormat.date().dayjs.add(1, 'day')).computerShortDate();

const CreateTreatment = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    CommonCheckBoxRenderer,
  },
  props: {
    edit: { default: false },
    title: { default: '' },
  },
  setup(props) {
    const { route, router } = useRouter();
    const successModal = ref(null);
    const step = ref(1);
    const refetchQuery = ref(false);
    const forceRender = ref(false);
    const subJobTableData = ref({ total: 0, data: [] });
    const getSuppliersResult = (data: any) => data.data.data;

    // Use to find bom item where has bom id
    const filter = computed(() => ({
      filterBomId: route.value.params.bomId,
      filterExceptStatus: 'CANCELLED',
    }));

    // Use to create purchase request, edit will implement later.
    const form = reactive({
      bomId: route.value.params.bomId,
      supplierId: -1,
      supplier: null,
      items: [],
      dueDate: NOW,
      status: 'PENDING',
      category: 'PRODUCTION',
      itemsType: 'MATERIALS',
      remarks: '',
      subType: 'HEAT_TREATMENT',
      supplierRemarks: '',
      discount: 0,
      sendDate: NOW,
      receiveDate: TOMORROW,
      call: async () => {
        if (props.edit) console.log('TO DO');
        else {
          await createPurchaseRequest(computedPurchaseRequestInput.value);
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ใบขอสั่งซื้อ' });
      },
      state: {
        value: 'READY',
      },
    });
    const vatType = ref('EX');
    const computedPurchaseRequestInput = computed(() => ({
      bomId: form.bomId,
      remarks: form.remarks,
      status: form.status || 'PENDING',
      dueDate: form.dueDate,
      category: form.category,
      itemsType: form.itemsType,
      subType: form.subType,
      supplierRemarks: form.supplierRemarks,
      sendDate: form.sendDate,
      receiveDate: form.receiveDate,
      items: form.items.map((item: any) => ({
        materialId: item.material.id,
        bomItemId: item.id,
        dueDate: form.dueDate,
        targetDate: form.dueDate,
        amount: parseFloat(item.amount),
      })).filter((item: any) => item.amount > 0),

      supplierId: (form.supplier as any)?.id,

      vatType: vatType.value,
    }));

    // Use to store which item already select
    const selectedItemId: Ref<number[]> = ref([]);
    // Use to finallize value that send to search api (Search api for find whole item that user choose to create PR)
    const searchValue: Ref<string | number[] | null> = ref(null);
    // Use to select item;
    function selectItem(id: number) {
      const hitIndex = selectedItemId.value.indexOf(id);
      if (selectedItemId.value.indexOf(id) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(id);
      if (selectedItemId.value.length !== subJobTableData.value.total) searchValue.value = selectedItemId.value;
      else searchValue.value = 'ALL';
    }
    function clearSelect() {
      selectedItemId.value = [];
      searchValue.value = [];
    }
    function selectAll() {
      forceRender.value = true;
      selectedItemId.value = subJobTableData.value.data.map((subJob: any) => subJob.id);
      searchValue.value = 'ALL';
      forceRender.value = false;
    }

    // Watch when route change;
    watch(() => route.value.params.bomId, async (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        step.value = 1;
        clearSelect();
        refetchQuery.value = true;
      }
    });

    // Hook when CommonRichTableWithAxios finish fetching data;
    // use this to check total record & how many user has select item.
    function receiveSubJobData(data: any) {
      subJobTableData.value = {
        data: data.data,
        total: data.total,
      };
    }

    // use this to manually paginate create pr page;
    const page = ref(1);
    const PERPAGE = 8;
    const createPurchaseRequestPaginator = computed(() => ({
      perPage: PERPAGE,
      total: form.items.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
      totalPages: form.items.length === 0 ? 1 : Math.ceil(form.items.length / PERPAGE),
    }));
    async function forward() {
      const result = await searchSubJob({ ids: searchValue.value, bomId: 'ALL' });
      form.items = result.map((item: any) => ({
        ...item,
        neededAmount: item.amount,
        totalPrice: 0,
        amount: parseFloat(item.amount).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
      }));
      step.value = 2;
    }
    async function backward() {
      router.push({ name: 'SubJobQCList' });
    }
    const displayRow = computed(() => {
      if (form.items.length < createPurchaseRequestPaginator.value.to) return form.items.slice(createPurchaseRequestPaginator.value.from, form.items.length);
      return form.items.slice(createPurchaseRequestPaginator.value.from, createPurchaseRequestPaginator.value.to);
    });

    // Handle "instantSearch" if redirect from PanelWithPurchaseOrderItemTable component
    async function handleInstanceSearchQuery() {
      if (route.value.query.instantSearch) {
        if (route.value.query.instantSearch === 'string' && route.value.query.instantSearch !== 'ALL') {
          selectedItemId.value = [parseInt(route.value.query.instantSearch, 10)];
          searchValue.value = [parseInt(route.value.query.instantSearch, 10)];
        } else if (!Array.isArray(route.value.query.instantSearch)) {
          selectedItemId.value = [route.value.query.instantSearch];
          searchValue.value = [route.value.query.instantSearch];
        } else {
          selectedItemId.value = route.value.query.instantSearch;
          searchValue.value = route.value.query.instantSearch;
        }
        await forward();
      }
    }

    onMounted(async () => {
      await handleInstanceSearchQuery();
    });

    const computedSupplierAddress = computed(() => {
      if (!(form.supplier) || !(form.supplier as any).province_id) return '';
      if (!(form.supplier as any).district_id) return '';
      if (!(form.supplier as any).subdistrict_id) return '';
      const key = (form.supplier as any)?.show_as_english ? 'name_in_english' : 'name_in_thai';
      const subDistrict = (form.supplier as any).sub_district[key] !== 'NULL' ? (form.supplier as any).sub_district[key] : (form.supplier as any).sub_district.name_in_thai;
      return `${(form.supplier as any).address}${key === 'name_in_english' && (form.supplier as any).province_id !== 1 ? ' Tumbol ' : ' '}${subDistrict} ${(form.supplier as any).district[key]} ${(form.supplier as any).province[key]} ${(form.supplier as any).zipcode}`;
    });

    return {
      forceRender,
      successModal,
      step,
      forward,
      backward,

      vatType,

      filter,
      getSubJobs,
      refetchQuery,
      createTreatmentTableOption,
      selectItem,
      selectedItemId,
      searchValue,

      clearSelect,
      selectAll,
      form,

      displayRow,
      page,
      pagination: createPurchaseRequestPaginator,

      subJobTableData,
      receiveSubJobData,

      getSuppliers,
      getSuppliersResult,
      computedSupplierAddress,
    };
  },
});

export default CreateTreatment;
